module.exports = __webpack_public_path__ + "img/d5b4bce.png";